module.exports = __webpack_public_path__ + "img/Egoraptor + Mini Gore.35394454.png";